export class Preloader {

    quequePreloader = 0
    preloaderEl;

    constructor(containerId = null, inModal = false) {
        const containerDestination = containerId ? `#${containerId}` : '.main-content';
        const preloaderParentContainer = document.querySelector(containerDestination);
        this.preloaderEl = preloaderParentContainer ? preloaderParentContainer.querySelector('.preloader') : null;
    }

    setMessage(message) {
        if (this.preloaderEl) {
            this.preloaderEl.querySelector('#preloader-message').innerText = message;
        }
    }

    open() {
        if (this.preloaderEl) {
            this.preloaderEl.classList.add('d-block');
            this.preloaderEl.classList.remove('d-none');
            this.preloaderEl.style.opacity = '1';
            this.quequePreloader++
        }
    }

    close() {
        if (this.preloaderEl) {
            this.quequePreloader--
            this.quequePreloader = this.quequePreloader < 0 ? 0 : this.quequePreloader
            if (this.quequePreloader == 0) {
                this.preloaderEl.style.opacity = '0';
                this.preloaderEl.style.display = 'none';
                this.preloaderEl.classList.add('d-none');
                this.preloaderEl.classList.remove('d-block');
            }
        }
    }
}



